// extracted by mini-css-extract-plugin
module.exports = {"list":"HamburgerContent_list__BaULd"};